import { createBrowserRouter, Navigate } from 'react-router-dom';
import { SystemRole } from '@fleet/shared';
import { AppLayout } from './AppLayout';
import { RequireRole } from './auth/RequireRole';
import { CalendarPage } from './calendar/CalendarPage';
import { MyBookings } from './bookings/MyBookings';
import { ApprovalInbox } from './approvals/ApprovalInbox';
import { PrivacyNoticePage } from './privacy/PrivacyNoticePage';
import { AdminLayout } from './admin/AdminLayout';
import { VehicleGroupsPage } from './admin/vehicle-groups/VehicleGroupsPage';
import { SlackConfigPage } from './admin/vehicle-groups/SlackConfigPage';
import { VehiclesPage } from './admin/vehicles/VehiclesPage';
import { AllBookingsPage } from './admin/bookings/AllBookingsPage';
import { PermissionEditorPage } from './admin/permissions/PermissionEditorPage';
import { DevicesPage } from './admin/telematics/DevicesPage';
import { RawTelemetryPage } from './admin/telematics/RawTelemetryPage';
import { UsersPage } from './admin/users/UsersPage';
import { IntegrationsPage } from './admin/integrations/IntegrationsPage';

/**
 * Echte Adressen statt umgeschalteter Zustände.
 *
 * Der Grund ist nicht die Optik: Der Berechtigungs-Editor gehört zu *einer*
 * Fahrzeuggruppe, und ohne Adresse gäbe es keinen Weg, dorthin zu verlinken oder
 * nach dem Neuladen wieder anzukommen. Der SPA-Fallback dafür steht bereits in
 * der nginx-Konfiguration.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <CalendarPage /> },
      { path: 'bookings', element: <MyBookings /> },
      { path: 'approvals', element: <ApprovalInbox /> },
      // Eigene Adresse, damit der Hinweis auch ohne Buchungsvorgang erreichbar
      // und aus einer Betriebsvereinbarung heraus verlinkbar ist.
      { path: 'datenschutz', element: <PrivacyNoticePage /> },
      {
        path: 'admin',
        element: <RequireRole roles={[SystemRole.ADMIN, SystemRole.FLEET_MANAGER]} />,
        children: [
          // Die Unterreiter erst innerhalb der Schranke: Wer keinen Zugriff
          // hat, soll den Hinweis sehen und nicht eine Navigation, die ins
          // Leere führt.
          {
            element: <AdminLayout />,
            children: [
              { index: true, element: <Navigate to="/admin/vehicles" replace /> },
              { path: 'vehicles', element: <VehiclesPage /> },
              { path: 'bookings', element: <AllBookingsPage /> },
              { path: 'vehicle-groups', element: <VehicleGroupsPage /> },
              { path: 'vehicle-groups/:id/permissions', element: <PermissionEditorPage /> },
              { path: 'vehicle-groups/:id/slack', element: <SlackConfigPage /> },
              { path: 'devices', element: <DevicesPage /> },
              { path: 'users', element: <UsersPage /> },
              { path: 'integrations', element: <IntegrationsPage /> },
              { path: 'telemetry', element: <RawTelemetryPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
